import { ClusterCommunityDto } from '@cradua/data';
import { environment } from 'apps/epims/mrsoftepims/src/environments/environment';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ClusterCommunityService {
  url = environment.apiUrl;
  constructor(private http: HttpClient) {}

  getClusterCommunity(): Observable<ClusterCommunityDto[]> {
    return this.http.get<ClusterCommunityDto[]>(this.url + 'cluster-community');
  }

  createClusterCommunity(
    data: ClusterCommunityDto[]
  ): Observable<ClusterCommunityDto[]> {
    return this.http.post<ClusterCommunityDto[]>(
      this.url + 'cluster-community',
      data
    );
  }
  getSingleClusterCommunity(id: string): Observable<any> {
    return this.http.get(this.url + 'cluster-community/' + id);
  }

  updateClusterCommunity(
    data: ClusterCommunityDto[]
  ): Observable<ClusterCommunityDto[]> {
    return this.http.post<ClusterCommunityDto[]>(
      this.url + 'cluster-community/update',
      data
    );
  }

  deleteClusterCommunity(ids: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: ids,
    };

    let params = new HttpParams();
    params = params.append('cluster-community', ids.join(', '));
    return this.http.delete(this.url + 'cluster-community', httpOptions);
  }
}
